/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it replace all matches?`)
};

const es_fr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Reemplaza todas las coincidencias?`)
};

const de_fr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werden alle Übereinstimmungen ersetzt?`)
};

const nl_fr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vervangt het alle overeenkomsten?`)
};

const fr_fr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplace-t-il toutes les correspondances ?`)
};

const it_fr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituisce tutte le corrispondenze?`)
};

const pt_br2_fr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele substitui todas as correspondências?`)
};

const pt_fr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substitui todas as correspondências?`)
};

const ja_fr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのマッチを置換しますか？`)
};

const zh_fr_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它会替换所有匹配项吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_faq2_q", locale)
	if (locale === "en") return en_fr_faq2_q(inputs)
	if (locale === "es") return es_fr_faq2_q(inputs)
	if (locale === "de") return de_fr_faq2_q(inputs)
	if (locale === "nl") return nl_fr_faq2_q(inputs)
	if (locale === "fr") return fr_fr_faq2_q(inputs)
	if (locale === "it") return it_fr_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_fr_faq2_q(inputs)
	if (locale === "pt") return pt_fr_faq2_q(inputs)
	if (locale === "ja") return ja_fr_faq2_q(inputs)
	return zh_fr_faq2_q(inputs)
};